import { BASE_URL,  RESELLERS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IReseller, IResellerInput } from "models/reseller";


export async function getReseller(params: string = "") : Promise<IReseller[]> {
  const response = await axios.get(BASE_URL + RESELLERS + params);
  return response.data;
}

export async function addReseller(data: IResellerInput) {
  const response = await axios.post(BASE_URL + RESELLERS, data);
  return response.data;
}
export async function editReseller(data: IResellerInput, id: string) {
  const response = await axios.patch(BASE_URL + RESELLERS + "/" + id , data);
  return response.data;
}

export async function deleteReseller(id: string) {
  const response = await axios.delete(BASE_URL + RESELLERS + "/" + id);
  return response.data;
}


export const ResellersCells: HeadCell[] = [
  {
    id: "resellerName",
    numeric: false,
    disablePadding: false,
    label: "Reseller Name",
    
  },
  {
    id: "countryCode",
    numeric: false,
    disablePadding: false,
    label: "Country Code",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "Phone Number",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];